import m from "../../geodata/es2015/samoaHigh";
window.am4geodata_samoaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/samoaHigh.js
// module id = null
// module chunks = 